import React, { VFC } from 'react';
import styled from 'styled-components';

interface Props extends React.HTMLProps<HTMLDivElement> {
  color?: string;
  borderHeight?: number;
}

const StyledDivider = styled.div<Props>`
  display: block;
  flex: 1;
  height: ${({ borderHeight }) => borderHeight}px;
  background-color: ${({ color }) => color};
`;

const Divider: VFC<Props> = ({
  color = '#E0E0E0',
  borderHeight = 1,
  style,
}) => <StyledDivider color={color} borderHeight={borderHeight} style={style} />;
export default Divider;
